export default "__VITE_ASSET__BxGXaRX0__"